/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type DeleteJobSubComponentModal_item$ref: FragmentReference;
declare export opaque type DeleteJobSubComponentModal_item$fragmentType: DeleteJobSubComponentModal_item$ref;
export type DeleteJobSubComponentModal_item = {|
  +id: string,
  +name: string,
  +$refType: DeleteJobSubComponentModal_item$ref,
|};
export type DeleteJobSubComponentModal_item$data = DeleteJobSubComponentModal_item;
export type DeleteJobSubComponentModal_item$key = {
  +$data?: DeleteJobSubComponentModal_item$data,
  +$fragmentRefs: DeleteJobSubComponentModal_item$ref,
};
*/


const node/*: ReaderFragment*/ = {
  "kind": "Fragment",
  "name": "DeleteJobSubComponentModal_item",
  "type": "Item",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "id",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "name",
      "args": null,
      "storageKey": null
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = '17a7a1dd42424c95e17a718db3abe94e';
module.exports = node;
